// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.sidebar-crm-description[data-v-1de4c88a] {\n\tmargin: 8px 20px 4px 20px;\n\tpadding: 10px 12px;\n\tbackground: var(--main-gray-1);\n\tborder-radius: 6px;\n\tfont-size: 13px;\n\tcolor: var(--main-gray-7, #1f2937);\n\twhite-space: pre-line;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
